var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.93,
    height: 26.155,
    viewBox: "0 0 31.93 26.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 31.93,
    height: 26.155,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M35.362,20.006,39.1,18.383A39.557,39.557,0,0,0,42.89,19.81V26.7h3.247s1.722.3,1.722-1.082V17.35s2.657-.443,2.9-2.411C49.679,13.66,39.643,5,39.643,5V.819H37.97V5.05L27.1,14.5s.049,2.46,2.411,2.116v8.511s.148,1.525,1.033,1.525h4.723s.025-6.716.1-6.642",
    transform: "translate(-18.832 -0.569)",
    fill: "#003E7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M42.577,24.367,35,30.812s2.116,2.362,3.69.886,3.887-7.33,3.887-7.33",
    transform: "translate(-24.324 -16.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M59.892,19.851,57.58,28.658a5.64,5.64,0,0,0,5.215,0c-.836-2.558-2.9-8.807-2.9-8.807",
    transform: "translate(-40.016 -13.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M71.936,24.851l3.345,6.937s2.607,1.033,4.477-.3",
    transform: "translate(-49.993 -17.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M70.323.1l.2,3a13.854,13.854,0,0,1,3.2.2C74.7,3.6,78,3.1,77.752.545c-1.574.443-2.116,1.574-3.788.59S70.422-.193,70.323.1",
    transform: "translate(-48.872 0)",
    fill: "#003E7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M13.481,11.611,12.4,12.6l-2.067-1.771L3.247,17.712H4.674v6.1H9.5v1.722H4.674s-1.328.148-1.328-1.525V19.04H0L9.545,9.348V5.658h.984V9.151Z",
    transform: "translate(0 -3.932)",
    fill: "#ed9c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M37.952,5.787,37.9,8a14.043,14.043,0,0,1,3.247.2c.886.3,2.362-1.328,2.558-2.362-.787.246-1.23,1.23-2.411.738s-3-1.279-3.346-.787",
    transform: "translate(-26.341 -3.914)",
    fill: "#ed9c2e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutdoor);
export default __webpack_public_path__ + "static/media/icon-outdoor.8a6c47f2da864b5cf08f6abafbfca89c.svg";
export { ForwardRef as ReactComponent };